import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: "59746460-8248-46e3-bd4b-b7b0378f4a6b", // global tenant prod ui spn
    authority:
      "https://login.microsoftonline.com/deff24bb-2089-4400-8c8e-f71e680378b2", // Azure AD Authority- Global tenant
    redirectUri: "https://ask.kewt-p.co.uk/", // EWS redirect URI
    postLogoutRedirectUri: "/" || window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true, // Works across all browsers
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
      logLevel: LogLevel.Warning,
    },
    allowRedirectBroker: false,
    windowHashTimeout: 9000,
    iframeHashTimeout: 9000,
    loadFrameTimeout: 9000,
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
  prompt: "select_account",
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
  graphPhotoEndpoint: "https://graph.microsoft.com/v1.0/me/photo/$value",
  scopes: [
    "api://5c62f163-aa78-4932-9791-cd929442f4e1/rag-backend-api/access_as_user",
  ],
};
